import React, { FunctionComponent } from "react";
import classNames from "classnames";

interface InfoItemProps {
  heading: string | React.ReactElement;
  content: string | string[];
  className?: string;
}

const InfoItem: FunctionComponent<InfoItemProps> = ({
  heading,
  content,
  className,
}) => (
  <div className={classNames("infoItem", className)}>
    {heading && <h3 className="h4 ds-u-margin--0">{heading}</h3>}
    {content ? (
      Array.isArray(content) ? (
        content.map((c, i) => (
          <p className="ds-text-body--md ds-u-margin--0" key={i}>
            {c}
          </p>
        ))
      ) : (
        <p className="ds-text">{content}</p>
      )
    ) : null}
  </div>
);

export default InfoItem;
